<div class="container-fluid">
	<form [formGroup]="myDetailForm">
		<div class="row paddingContainerActive">
			<div>
				<mat-label class="checkBoxPanel paddingLabel"
					>{{ "centro.centroData.active" | translate }}
					<mat-icon
						class="info"
						matSuffix
						[matTooltip]="
							'centro.centroData.tooltipActivo' | translate
						"
						>info</mat-icon
					>
				</mat-label>
				<mat-slide-toggle
					[checked]="centro?.activo"
					color="warn"
					formControlName="activo"
					[disabled]="
						!this.centro?.edicionCentro && !this.parent?.isCreating
					"
				>
				</mat-slide-toggle>
			</div>
		</div>
		<div class="row paddingContainer">
			<div class="col">
				<div class="inputBlock">
					<mat-label class="requerido"
						>{{ "centro.centroData.description" | translate }}
						<mat-icon
							class="info"
							matSuffix
							[matTooltip]="
								'centro.centroData.tooltipdescription'
									| translate
							"
							>info</mat-icon
						></mat-label
					>
					<input
						matInput
						type="text"
						[value]="centro?.descripcion | translate"
						class="dataInput"
						formControlName="descripcion"
						[readonly]="
							!this.centro.edicionCentro &&
							!this.parent?.isCreating
						"
					/>
					<mat-error
						*ngIf="
							f['descripcion'].errors &&
							f['descripcion'].invalid &&
							(f['descripcion'].dirty || f['descripcion'].touched)
						"
					>
						{{ "messages.requiredField" | translate }}
					</mat-error>
				</div>
				<div class="inputBlock select-container">
					<mat-label>{{
						"centro.centroData.cebesCenter" | translate
					}}</mat-label>
					<mat-select
						class="dataInput"
						[formControl]="this.parent.cebeControl"
						[disabled]="true"
					>
						<mat-option
							*ngFor="let item of this.parent.cebesSimples"
							[value]="item.id"
						>
							{{ item["descripcion"] }}
						</mat-option>
					</mat-select>
				</div>
				<div class="dataBlock">
					<div class="profile-container">
						<img
							#photoEmResponsable
							[src]="this.fotophotoResponsable"
							class="img-responsive profile-image"
							alt=""
						/>
						<div class="profile-content">
							<mat-form-field class="example-full-width">
								<mat-label class="requerido">{{
									"centro.centroData.plantManager" | translate
								}}</mat-label>
								<mat-icon
									class="info"
									matSuffix
									[matTooltip]="
										'centro.centroData.tooltipGerentePlanta'
											| translate
									"
									>info</mat-icon
								>
								<input
									type="text"
									[placeholder]="
										'shared.refineSearch' | translate
									"
									aria-label="Número"
									matInput
									class="dataInput"
									[formControl]="
										this.parent.responsableControl
									"
									[matAutocomplete]="auto"
									#nombreInput
									[readonly]="
										!this.centro.edicionCentro &&
										!this.parent?.isCreating
									"
								/>
								<cdk-virtual-scroll-viewport
									class="autocomplete-test-viewport"
									itemSize="50"
									minBufferPx="500"
									maxBufferPx="750"
								>
									<mat-autocomplete
										#auto="matAutocomplete"
										[displayWith]="this.parent.displayFn"
										(optionSelected)="
											this.parent.onOptionSelectedResponsable(
												$event
											)
										"
									>
										<mat-option
											*cdkVirtualFor="
												let option of this.parent
													.employeesfilterResponsable
													| async
											"
											[value]="option"
										>
											{{ option.nombre }}
										</mat-option>
									</mat-autocomplete>
								</cdk-virtual-scroll-viewport>
								<mat-error
									*ngIf="
										this.parent.responsableControl.hasError(
											'required'
										) &&
										this.parent.responsableControl.touched
									"
								>
									{{ "messages.requiredField" | translate }}
								</mat-error>
							</mat-form-field>
						</div>
					</div>
				</div>
				<div class="inputBlock select-container">
					<mat-label
						>{{ "centro.centroData.centerActivity" | translate }}
						<mat-icon
							class="info"
							[matTooltip]="
								this.translate.instant(
									'centro.centroData.descripActivityCenter'
								)
							"
							>info</mat-icon
						>
					</mat-label>
					<mat-select
						class="dataInput"
						formControlName="centroActividadID"
						[disabled]="
							!this.centro?.edicionCentro &&
							!this.parent?.isCreating
						"
					>
						<mat-option [value]="null"> </mat-option>
						<mat-option
							*ngFor="let item of centroActividadList"
							[value]="item.id"
						>
							{{
								"centro.centerActivities." + item.codigo
									| translate
							}}
						</mat-option>
					</mat-select>
					<mat-error
						*ngIf="
							f['centroActividadID'].errors &&
							f['centroActividadID'].invalid &&
							(f['centroActividadID'].dirty ||
								f['centroActividadID'].touched)
						"
					>
						{{ "messages.requiredField" | translate }}
					</mat-error>
				</div>
			</div>
			<div class="col">
				<div class="inputBlock select-container">
					<mat-label class="requerido">{{
						"centro.centroData.installationType" | translate
					}}</mat-label>
					<mat-select
						class="dataInput"
						formControlName="tipoInstalacionID"
						[disabled]="
							!this.centro?.edicionCentro &&
							!this.parent?.isCreating
						"
					>
						<mat-option
							*ngFor="let item of tipoInstalacionList"
							[value]="item.id"
						>
							{{
								"centro.installations." + item.codigo
									| translate
							}}
						</mat-option>
					</mat-select>
					<mat-error
						*ngIf="
							f['tipoInstalacionID'].errors &&
							f['tipoInstalacionID'].invalid &&
							(f['tipoInstalacionID'].dirty ||
								f['tipoInstalacionID'].touched)
						"
					>
						{{ "messages.requiredField" | translate }}
					</mat-error>
				</div>
				<div
					class="inputBlock select-container"
					*ngIf="cebe?.paisID == 65"
				>
					<mat-label class="requerido"
						>{{ "centro.centroData.provincia" | translate }}
					</mat-label>
					<mat-select
						class="dataInput"
						formControlName="localizacionID"
						[disabled]="
							!this.centro?.edicionCentro &&
							!this.parent?.isCreating
						"
					>
						<mat-option
							*ngFor="let item of localizacionList"
							[value]="item.id"
						>
							{{ item["descripcion"] }}
						</mat-option>
					</mat-select>
				</div>
				<div class="inputBlock" *ngIf="cebe?.paisID !== 65">
					<mat-label class="requerido">{{
						"centro.centroData.province" | translate
					}}</mat-label>
					<input
						matInput
						type="text"
						[value]="centro?.ciudad | translate"
						class="dataInput"
						formControlName="ciudad"
						[readonly]="
							!this.centro?.edicionCentro &&
							!this.parent?.isCreating
						"
					/>
				</div>
				<div class="row">
					<div class="col">
						<div class="inputBlock">
							<mat-label class="requerido">{{
								"centro.centroData.latitude" | translate
							}}</mat-label>
							<input
								matInput
								type="text"
								[value]="centro?.latitud | translate"
								class="dataInput"
								formControlName="latitud"
								[readonly]="
									!this.centro?.edicionCentro &&
									!this.parent?.isCreating
								"
							/>
							<mat-error
								*ngIf="
									f['latitud'].errors &&
									f['latitud'].invalid &&
									(f['latitud'].dirty || f['latitud'].touched)
								"
							>
								{{ "messages.requiredField" | translate }}
							</mat-error>
						</div>
					</div>
					<div class="col">
						<div class="inputBlock">
							<mat-label class="requerido">{{
								"centro.centroData.longitude" | translate
							}}</mat-label>
							<input
								matInput
								type="text"
								[value]="centro?.longitud | translate"
								class="dataInput"
								formControlName="longitud"
								[readonly]="
									!this.centro?.edicionCentro &&
									!this.parent?.isCreating
								"
							/>
							<mat-error
								*ngIf="
									f['longitud'].errors &&
									f['longitud'].invalid &&
									(f['longitud'].dirty ||
										f['longitud'].touched)
								"
							>
								{{ "messages.requiredField" | translate }}
							</mat-error>
						</div>
					</div>
				</div>
				<div class="inputBlockimagen">
					<mat-label>
						{{ "cebe.generalData.image" | translate }}
					</mat-label>

					<input
						type="file"
						accept="image/jpeg, image/png"
						(change)="onFileChange($event)"
						[disabled]="!cebe?.edicionCebe"
						class="dataInput custom-file-input"
					/>
				</div>
				<div *ngIf="!imagenPreview" class="mt-2">
					<small>{{
						"messages.imageRequiredType" | translate
					}}</small>
				</div>
				<div *ngIf="imagenPreview" class="mt-2">
					<img
						[src]="imagenPreview"
						alt="preview"
						style="
							max-width: 200px;
							border: 1px solid #ccc;
							padding: 4px;
						"
					/>
				</div>
			</div>
			<div class="col">
				<div class="inputBlock">
					<app-centro-map-card
						*ngIf="centro"
						class="h-100"
						[centro]="centro"
						[detailFormGroup]="myDetailForm"
					>
					</app-centro-map-card>
				</div>
			</div>

			<div class="buttonBlock container" *ngIf="isAdmin">
				<div class="row justify-content-around">
					<div class="col-auto">
						<button
							class="marginButton"
							type="submit"
							mat-raised-button
							color="warn"
							[disabled]="
								centro?.fechaValidacion
									? !(
											centro?.fechaValidacion <
												centro?.fechaModificacion &&
											(centro?.fechaListoMigra
												? centro?.fechaListoMigra <
														centro?.fechaValidacion ||
												  centro?.fechaListoMigra <
														centro?.fechaModificacion
												: true)
									  )
									: false
							"
							(click)="Validate()"
						>
							{{ "centro.centroData.validate" | translate }}
						</button>
					</div>
					<div class="col-auto">
						<button
							class="marginButton"
							type="submit"
							mat-raised-button
							color="warn"
							[disabled]="
								centro?.fechaListoMigra
									? centro?.fechaValidacion
										? !(
												centro?.fechaValidacion >
												centro?.fechaListoMigra
										  )
										: true
									: centro?.fechaValidacion
									? !(
											centro?.fechaValidacion >=
											centro?.fechaModificacion
									  )
									: true
							"
							(click)="Migrar()"
						>
							Migrar
						</button>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>

<!--
  <p>fechaModificacion {{this.centro?.fechaModificacion }}</p>
  <p>fechaValidacion {{this.centro?.fechaValidacion }}</p>
  <p>fechaListoMigra {{this.centro?.fechaListoMigra }}</p> 
-->
